const rankingItems = [
  { rank: 1, title: '创造营2026三公：黑马逆袭全记录', heat: '热度 982万', trend: 'up', change: '+3' },
  { rank: 2, title: '电竞世界杯预选赛黑马战队深度分析', heat: '热度 876万', trend: 'up', change: '+5' },
  { rank: 3, title: '歌手2026第六期赛制突变全程回顾', heat: '热度 754万', trend: 'up', change: '+1' },
  { rank: 4, title: '街舞大赛裁判评分争议持续发酵', heat: '热度 689万', trend: 'down', change: '-2' },
  { rank: 5, title: 'AI创作大赛获奖作品引发行业讨论', heat: '热度 612万', trend: 'up', change: '+8' },
  { rank: 6, title: '美食大赛冠军回归：新老对决前瞻', heat: '热度 534万', trend: 'new', change: '新' },
  { rank: 7, title: '本周大赛吃瓜十大名场面合集', heat: '热度 467万', trend: 'new', change: '新' },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            吃瓜热度榜
          </h2>
          <p className="text-sm text-foreground-500 mt-2">每日大赛吃瓜内容热度排行，看看今天什么最火</p>
        </div>

        <div className="bg-background-100 rounded-2xl overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 md:px-6 py-4 cursor-pointer hover:bg-primary-50/50 transition-colors duration-200 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-heading text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-white' :
                item.rank === 2 ? 'bg-accent-500 text-white' :
                item.rank === 3 ? 'bg-secondary-500 text-white' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base text-foreground-800 font-medium truncate">
                  {item.title}
                </h3>
              </div>
              <span className="text-xs text-foreground-400 whitespace-nowrap hidden sm:block">{item.heat}</span>
              <span className={`text-xs font-medium whitespace-nowrap ${
                item.trend === 'up' ? 'text-primary-500' :
                item.trend === 'down' ? 'text-secondary-500' :
                'text-accent-500'
              }`}>
                {item.change.startsWith('+') ? `↑${item.change}` :
                 item.change.startsWith('-') ? `↓${item.change.replace('-', '')}` :
                 item.change}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}